import { computed, inject, provide, type InjectionKey } from "vue";
import { useSocketsCountPresence } from "../ably/use-sockets-count-presence";
import { useChannelStore } from "@/stores/channel.store";

const onlineNowInjectionKey = Symbol("onlineNow") as InjectionKey<
  ReturnType<typeof useProvideOnlineNow>
>;

export function useProvideOnlineNow() {
  const channelStore = useChannelStore();

  const channelSlug = computed(() => channelStore.channelSlug ?? "all");

  const onlineNowPresence = useSocketsCountPresence({
    channelSlug,
  });

  const definition = {
    onlineNow: onlineNowPresence.connectionsCount,
    isOnlineNowLoaded: onlineNowPresence.isLoaded,
  };

  provide(onlineNowInjectionKey, definition);
  return definition;
}

export function useOnlineNow() {
  const value = inject(onlineNowInjectionKey);

  if (!value) {
    throw new Error("useOnlineNow() is called without providing the context");
  }

  return value;
}
